import { ThemeEvents } from '@theme/events';

const TARGET_ID = 'product-list';

const revealHeader = () => {
  const header = document.querySelector('.header[data-sticky-state]');
  if (!header) return;
  header.removeAttribute('data-animating');
  header.setAttribute('data-sticky-state', 'active');
};

document.addEventListener(
  'click',
  (event) => {
    const target = /** @type {Element | null} */ (event.target);
    if (!target?.closest?.('.add-to-cart-button')) return;
    revealHeader();
  },
  { capture: true }
);

document.addEventListener(ThemeEvents.cartUpdate, (event) => {
  const data = event?.detail?.data;
  if (!data || data.didError) return;
  if (data.source !== 'product-form-component') return;

  revealHeader();

  const target = document.getElementById(TARGET_ID);
  if (!target) return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  target.scrollIntoView({ behavior: reducedMotion ? 'instant' : 'smooth', block: 'start' });
});
